import { useParams } from 'react-router-dom';

import { ForecasterPurposeInputsProvider } from '../purpose/context/ForecasterPurposeInputsContext';
import { ForecasterPurposeProjectionProvider } from '../purpose/context/ForecasterPurposeProjectionContext';

export const ForecasterPurposeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { purposeId } = useParams<{ purposeId?: string }>();

  if (!purposeId) return children;

  return (
    <ForecasterPurposeInputsProvider>
      <ForecasterPurposeProjectionProvider>{children}</ForecasterPurposeProjectionProvider>
    </ForecasterPurposeInputsProvider>
  );
};
